import React from "react";
import "./ScheduleErrorBoundary.css";

// Contains a render crash to a panel instead of white-screening the whole app.
// A single TypeError in one view (e.g. the dispatch board) should degrade that
// view, not blank the page — that failure mode turned a one-line bug into a
// multi-hour incident. Reset on navigation (keyed by pathname in the parent).
export default class ScheduleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface to console for debugging; the panel stays contained.
    // eslint-disable-next-line no-console
    console.error(`[ScheduleErrorBoundary${this.props.label ? `:${this.props.label}` : ""}]`, error, info?.componentStack);
  }

  handleReset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="sched-eb">
          <div className="sched-eb-card">
            <div className="sched-eb-title">This view hit an error</div>
            <div className="sched-eb-msg">
              The rest of Schedule still works — switch tabs or retry. If it keeps happening, the detail is in the console.
            </div>
            <div className="sched-eb-detail">{String(this.state.error?.message || this.state.error)}</div>
            <button className="sched-eb-btn" onClick={this.handleReset}>Retry</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
